// extracted by mini-css-extract-plugin
module.exports = {"cookiesPopup":"CookiesPopup_cookiesPopup__O11RL","slideUp":"CookiesPopup_slideUp__PXT_u","slideDown":"CookiesPopup_slideDown__YzN2s"};